import React from 'react'

import { B5, Icon, Stack, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { LinearGradient } from 'expo-linear-gradient'

import StarSingle from '../../../assets/svg/starSingle.svg'
import MagnetTextComp from './magnetTextComp'

type Props = {
  customerName?: string
}

const MagnetStrip = ({ customerName }: Props) => {
  return (
    <LinearGradient
      colors={['#140326', '#591FA8']}
      start={[0, 0]}
      end={[1, 0.0]}
      locations={[0.0, 0.93]}
      className="px-3"
    >
      <XStack className="items-center justify-between py-3">
        <XStack className="flex-1 items-center">
          <Stack className="mr-2">
            <StarSingle />
          </Stack>
          {i18n.locale == 'en' ? (
            <B5 className="bg-red flex-1 items-center justify-center text-white">
              {customerName}
              {i18n.t('magnetCrossSelling.magnetOnListing.isEligibleFor')}
              <MagnetTextComp />
            </B5>
          ) : (
            <B5 className="bg-red flex-1 items-center justify-center text-white">
              {customerName + ' '}
              <MagnetTextComp />
              {i18n.t('magnetCrossSelling.magnetOnListing.isEligibleFor')}
            </B5>
          )}
        </XStack>
        <Icon type="ArrowRight" color="#fff" size={24} />
      </XStack>
    </LinearGradient>
  )
}

export { MagnetStrip }
